/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { createAction } from 'redux-actions'
import { SET_PRICE_DATA_RECENT_AVERAGES, SET_PRICE_DATA_YOY_CHANGE } from '../constants/index'

export const setPriceDataRecentAverages = createAction<
  ReadonlyArray<number | undefined>,
  typeof SET_PRICE_DATA_RECENT_AVERAGES
>(SET_PRICE_DATA_RECENT_AVERAGES)
export const setPriceDataYOYChange = createAction<
  number[] | null | undefined,
  typeof SET_PRICE_DATA_YOY_CHANGE
>(SET_PRICE_DATA_YOY_CHANGE)
